var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyPosition = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 119 119",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M58.201 110.454H60.8M45.59 40.636H14.21a5.667 5.667 0 0 0-5.663 5.662v64.156M110.454 110.454V46.298a5.667 5.667 0 0 0-5.663-5.662H73.178",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.455 25.053h20.498V83.64H41.704M59.5 92.122V8.557M85.662 25.053H67.047V83.64h9.301",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5 8.557A3.779 3.779 0 1 0 59.5 1a3.779 3.779 0 0 0 0 7.557ZM27.687 28.831a3.779 3.779 0 1 0 0-7.557 3.779 3.779 0 0 0 0 7.557ZM89.43 28.831a3.779 3.779 0 1 0 0-7.557 3.779 3.779 0 0 0 0 7.557Z",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M45.589 101.587h-26.91a1.883 1.883 0 0 1-1.884-1.884V51.375c0-1.041.842-1.883 1.884-1.883h26.91M73.178 49.492h27.144c1.041 0 1.883.842 1.883 1.883v48.328a1.883 1.883 0 0 1-1.883 1.884H74.067M53.837 110.454H1v1.884L6.663 118h105.674l5.663-5.662v-1.884H65.163",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgEmptyPosition;